<template>
  <svg viewBox="-2.5 -2.5 125 125" fill="none" aria-hidden="true">
    <defs>
      <mask id="eye-cutout">
        <rect x="-2.5" y="-2.5" width="125" height="125" fill="white" />
        <circle cx="45" cy="35" r="6" fill="black" />
        <circle cx="75" cy="35" r="6" fill="black" />
      </mask>
    </defs>
    <path
      d="M60 10 C30 10 15 35 15 55 C15 75 30 95 45 100 L45 110 L55 110 L55 100 C55 100 60 102 65 100 L65 110 L75 110 L75 100 C90 95 105 75 105 55 C105 35 90 10 60 10Z"
      fill="currentColor"
      mask="url(#eye-cutout)" />
    <path d="M20 45 C5 40 0 50 5 60 C10 70 20 65 25 55 C28 48 25 45 20 45Z" fill="currentColor" />
    <path d="M100 45 C115 40 120 50 115 60 C110 70 100 65 95 55 C92 48 95 45 100 45Z" fill="currentColor" />
    <path d="M45 15 Q35 5 30 8" stroke="currentColor" stroke-width="3" stroke-linecap="round" />
    <path d="M75 15 Q85 5 90 8" stroke="currentColor" stroke-width="3" stroke-linecap="round" />
  </svg>
</template>
